/** Englische Fassungen für den Bereich „konto" (Schlüssel = deutscher Satz). */
export const EN_KONTO: Record<string, string> = {
  // Einstellungen
  'Gilt für alle Projekte: Konto, Darstellung, Developer-Apps, Generatoren und Diagnose.': 'Applies to all projects: account, appearance, developer apps, generators and diagnostics.',
  'Gilt für alle Projekte: Konto, Darstellung und welche Generatoren deine Rezepte nutzen dürfen.': 'Applies to all projects: account, appearance and which generators your recipes may use.',
  'Darstellung': 'Appearance',
  'Farbschema': 'Color scheme',
  '„System" folgt der Einstellung deines Geräts, auch wenn sie sich abends ändert.': '"System" follows your device setting, even when it changes in the evening.',
  'Hell': 'Light',
  'Dunkel': 'Dark',
  'System': 'System',
  'Sprache': 'Language',
  'Betrifft nur die Oberfläche. Die Sprache deiner Beiträge legst du im Projekt fest.': 'Affects the interface only. The language of your posts is set per project.',
  'Tipps „So funktioniert\'s"': '"How it works" tips',
  'Kurze Erklärungen oben auf den Seiten. Nach den ersten Tagen meist entbehrlich.': 'Short explanations at the top of pages. Usually unnecessary after the first few days.',
  'Tipps anzeigen': 'Show tips',
  'Akzentfarbe': 'Accent color',
  'nur Betreiber': 'operators only',
  'Zum Vergleichen, bis die Entscheidung steht. Gilt nur in diesem Browser.': 'For comparing until the decision is made. Applies to this browser only.',
  'Ultramarin': 'Ultramarine',
  'Tangerine': 'Tangerine',
  'Smaragd': 'Emerald',
  'Generatoren': 'Generators',
  'Was aktiv ist, kannst du in deinen Rezepten wählen. Ein Anbieter wird aktiv, sobald sein Key hier steht und funktioniert.': 'Whatever is active can be chosen in your recipes. A provider becomes active once its key is entered here and works.',
  'Was aktiv ist, können deine Rezepte nutzen.': 'Whatever is active can be used by your recipes.',
  'Planung, Texte und Bilder sind abgedeckt. Der Agent kann loslegen.': 'Planning, copy and images are covered. The agent is ready to go.',
  'optional, für gesprochene Beiträge': 'optional, for posts with voice-over',

  // Musik
  'Tracks für alle Projekte. Beim Rendern werden sie fest unter das Video gelegt.': 'Tracks for all projects. They are mixed permanently into the video when rendering.',
  'Wie die Musik in den Beitrag kommt': 'How the music gets into the post',
  'Track löschen?': 'Delete track?',
  'Löschen fehlgeschlagen': 'Delete failed',
  'Zur Lizenz': 'About licensing',

  // Anmeldung
  'Anmelden oder Konto anlegen': 'Sign in or create account',
  'Standardmäßig wartet jeder Beitrag auf dein OK. Vollautomatisch nur, wenn du es einschaltest.': 'By default every post waits for your OK. Fully automatic only if you turn it on.',
  'Du bekommst Startguthaben, genug für die ersten Beiträge, ohne Zahlungsdaten.': 'You get starter credits, enough for your first posts, no payment details needed.',

  // Assistent
  'Automatik einstellen': 'Set up automation',
  'Beiträge durchsehen': 'Review posts',
  'Beitrag ändern': 'Edit post',
  'Beiträge freigeben': 'Approve posts',
  'Beiträge verwerfen': 'Discard posts',
  'Bau mir 3 Beiträge für nächste Woche': 'Build me 3 posts for next week',
  'Was kostet ein Video-Beitrag?': 'What does a video post cost?',
  'Schreib die Caption vom letzten wartenden Beitrag frecher': 'Make the caption of the latest waiting post bolder',
  'Sag einfach, was passieren soll. Ich lege Projekte an, plane Beiträge, schreibe Captions um, stelle den Zeitplan ein und gebe Beiträge frei, du schaust zu.': 'Just say what should happen. I create projects, plan posts, rewrite captions, set the schedule and approve posts while you watch.',
  'Der Assistent darf Beiträge live schalten.': 'The assistant may publish posts.',
  'Der Assistent baut nur. Jeder Beitrag wartet auf dein OK.': 'The assistant only builds. Every post waits for your OK.',
  'Senden': 'Send',

  // Projekt löschen
  '„{name}" gelöscht, {posts} Beiträge und {files} Dateien entfernt.': '"{name}" deleted, {posts} posts and {files} files removed.',

  // Wissen & Screenshots
  'Wird vor jedem Beitrag mitgelesen. Zusammen {chars} Zeichen': 'Read before every post. {chars} characters in total',
  'Ziemlich viel. Alles davon wird bei jedem einzelnen Lauf mitgeschickt und kostet entsprechend Credits. Mehr Unterlagen machen die Beiträge nicht automatisch besser — nur das, was wirklich beschreibt, was die App für Menschen tut.': 'That\'s quite a lot. All of it is sent with every single run and costs credits accordingly. More documents don\'t automatically make posts better — only what truly describes what the app does for people.',
  'Beitragsideen': 'Post ideas',
  'Beitragsideen gespeichert.': 'Post ideas saved.',
  'Damit manche Beiträge die App wirklich zeigen können: ein Handy in der Hand, die App offen auf dem Tisch. Ohne Vorlage denkt sich das Bildmodell eine Oberfläche aus, die deiner App nicht ähnlich sieht.': 'So some posts can really show the app: a phone in hand, the app open on the table. Without a reference, the image model invents an interface that looks nothing like your app.',
  'Screenshots hinzufügen': 'Add screenshots',
  'Noch keine Screenshots. Solange keine da sind, zeigt kein Beitrag die App.': 'No screenshots yet. Until there are some, no post shows the app.',
  'Kein Beitrag zeigt die App. Die Screenshots bleiben ungenutzt.': 'No post shows the app. The screenshots stay unused.',
  'Ungefähr jeder {n}. Beitrag zeigt die App, der Rest erzählt das Thema ohne sie.': 'Roughly every {n}th post shows the app; the rest tell the story without it.',
  'Einrichtung prüfen': 'Check setup',
  'Link lesen': 'Read link',
  'Bilder speichern': 'Save images',
  'Rezepte ansehen': 'View recipes',
  'Rezept einstellen': 'Set up recipe',
  'Rezept anlegen': 'Create recipe',
  'Posts bauen': 'Build posts',
  'Richte mit mir ein neues Projekt ein': 'Set up a new project with me',
  'Wie funktioniert das hier?': 'How does this work?',
  'Was fehlt noch bei der Einrichtung?': 'What\'s still missing in the setup?',
  'Ich lade dir Screenshots und mein Logo hoch': 'I\'ll upload screenshots and my logo',
  'Bau mir 2 Posts': 'Build me 2 posts',
  'Hier gehen nur Bilder (PNG, JPG, WebP).': 'Only images work here (PNG, JPG, WebP).',
  'Hochladen fehlgeschlagen': 'Upload failed',
  'Bild ließ sich nicht hochladen': 'Image couldn\'t be uploaded',
  'Hier sind meine Bilder.': 'Here are my images.',
  'Neu': 'New',
  'Sag einfach, was passieren soll. Ich richte Projekte mit dir ein, nehme Screenshots und dein Logo entgegen, stelle Rezepte ein, baue Beiträge und gebe sie frei. Du schaust zu.': 'Just say what should happen. I set up projects with you, take your screenshots and logo, configure recipes, build posts and approve them. You watch.',
  'Bilder kannst du einfach hier hineinziehen oder einfügen.': 'You can drag or paste images right here.',
  'Entfernen': 'Remove',
  'Bilder anhängen': 'Attach images',
  'Bilder hier loslassen': 'Drop images here',
};
